import "./DefaultModal.css";

import "bootstrap/dist/css/bootstrap.min.css";
import PropTypes from "prop-types";

import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";

import CloseIconGray from "../../assets/imgs/close-icon-gray.svg";

const DefaultModal = ({
  title,
  description,
  showModal,
  onClose,
  children,
  className,
  centered = true,
}) => {
  const [openModal, setOpenModal] = React.useState(showModal);

  const handleCloseModal = () => {
    setOpenModal(false);
    onClose();
  }


  useEffect(() => {
    setOpenModal(showModal);
  }, [showModal]);

  return (
    <>
      <div className="default-modal__modal">
        <Modal
          show={openModal}
          onHide={handleCloseModal}
          onExit={handleCloseModal}
          className={className || ''}
          centered={centered}
        >
          <div className="default-modal__modal__header">
            <div className="default-modal__modal__header__info">
              <h4>{title}</h4>
              {description && <p>{description}</p>}
            </div>
            <a 
              className="default-modal__modal__close"
              href="javascript:;"
              onClick={handleCloseModal}
            >
              <img src={CloseIconGray} alt="Fechar" onClick={handleCloseModal} />
            </a>
          </div>
          <div className="default-modal__modal__content">
            {children}
          </div>
        </Modal>
      </div >
    </>
  );
};

DefaultModal.propTypes = {
  title: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  centered: PropTypes.bool,
};

export default DefaultModal;
